const {convertMS,coordsDistance} = require("../util/utils")
const {insideGeofence} = require("../util/geofence");
const jsPDF = require('jspdf')
require('jspdf-autotable')
const reportStyle = require("./../reportStyle")
const speeding_localidade_ligeiro = 60
const speeding_localidade_pesado = 50
const speeding_fora_localidade_ligeiro = 80
const speeding_fora_localidade_pesado = 65

let traccarInstance

async function createVistaWasteActivityReport(from, to, userData, traccar) {
    console.log('Create customreport_vistawaste_activity')
    traccarInstance = traccar
    const reportData = {
        devices: []
    }

    const estaleiros = [
        {
            "name": "ESTALEIRO KILAMBA",
            "area": "POLYGON((-8.99036238 13.28504777, -8.99039417 13.28641302, -8.99115450 13.28639961, -8.99111477 13.28502631, -8.99036238 13.28504777))"
        },
        {
            "name": "ESTALEIRO CAMAMA",
            "area": "POLYGON((-8.90046068 13.25974549, -8.90163723 13.25978841, -8.90161074 13.26026047, -8.90160279 13.26074327, -8.90044479 13.26061988, -8.90046068 13.25974549))"
        },
        {
            "name": "ESTALEIRO MORRO BENTO",
            "area": "POLYGON((-8.89844343 13.18852632, -8.89869186 13.18842876, -8.89892439 13.18829900, -8.89928610 13.18797513, -8.89958024 13.18752854, -8.89836393 13.18705379, -8.89788694 13.18794428, -8.89780082 13.18811728, -8.89844343 13.18852632))"
        },
        {
            "name": "ESTALEIRO VIANA",
            "area": "POLYGON((-8.959712366859051 13.398229886846394,-8.961936865901805 13.398784062152373,-8.962332683987768 13.397008438266084,-8.960161022571128 13.396436337157951,-8.959712366859051 13.398229886846394))"
        }
    ]

    const aterros = [
        {
            "name": "ATERRO MULENVOS",
            "area": "POLYGON((-8.84199831467157 13.353586792945864, -8.837055409386934 13.360404968261719, -8.839133292931493 13.363355398178099, -8.844725497826346 13.367915153503418, -8.849093189309215 13.361692428588865, -8.850407727084232 13.358130455017088, -8.848955374593118 13.357014656066895, -8.847980068973513 13.356928825378414, -8.84745001048762 13.356692790985106, -8.846729129721837 13.356049060821531, -8.84594198992049 13.35538923740387, -8.845441081897903 13.35453629493713, -8.84399666076834 13.35343658924103, -8.84199831467157 13.353586792945864))"
        }
    ]

    const localidades = [
        {
            "name": "LOCALIDADE LUANDA",
            "area": "POLYGON((-8.955958201666093 13.138961791992184, -8.988513900385996 13.180847167968746, -8.979697020449052 13.218612670898434, -8.978340558346787 13.330535888671871, -8.985122818104188 13.404006958007809, -8.935609408774312 13.444519042968746, -8.835883944366856 13.435592651367184, -8.804671778278191 13.408813476562498, -8.756491311686318 13.389587402343748, -8.740203543653791 13.205566406249996, -8.955958201666093 13.138961791992184))"
        }
    ]

    const devices = userData.devices
    devices.sort((a, b) => (a.name > b.name) ? 1 : -1)


    let speeding_localidade = 0
    let speeding_fora_localidade = 0
    for (const device of devices) {

        const deviceActivities = {
            activities: [],
            entradas_em_aterro: 0,
            km: 0,
            tempo_em_trabalho: 0,
            tempo_em_recolha: 0,
            tempo_em_aterro: 0,
            tempo_em_regresso: 0,
            horas_extra: 0,
            tempo_excesso_localidade: 0,
            tempo_excesso_fora_localidade: 0,
            viagens_sem_driver: 0
        }

        const timer_start = new Date(Date.now())

        if(device.category === 'truck') {
            speeding_localidade = speeding_localidade_pesado
            speeding_fora_localidade = speeding_fora_localidade_pesado
        } else {
            speeding_localidade = speeding_localidade_ligeiro
            speeding_fora_localidade = speeding_fora_localidade_ligeiro
        }

        let in_estaleiro_old = undefined
        let in_aterro_old
        let fixtime_old
        let coord_old

        let service_counter = 0
        let estaleiro_name = ''

        let service_status = 'fora'

        console.log('- Getting position List' + ' Device:' + device.id)
        let response
        try {
            response = await traccarInstance.reports.reportsRouteGet(from, to, [device.id])
        }
        catch (error) {
            console.log(error)
        }

        const position_list = response ? response.data : []

        const current_activity = {}

        console.log('- Analyzing route - positions:'+position_list.length)
        for (let i = 0 ; i < position_list.length ; i++) {

            const position = position_list[i]

            //verifica se a posição está num Estaleiro
            let in_estaleiro = false
            for (let j = 0 ; j < estaleiros.length ; j++) {
                const estaleiro = estaleiros[j]
                if (insideGeofence(position, estaleiro)){
                    in_estaleiro = true
                    estaleiro_name = estaleiro['name']
                    break
                }
            }

            //verifica se a posição está num Aterro
            let in_aterro = false
            let aterro_name = ""
            for (let j = 0 ; j < aterros.length ; j++) {
                const aterro = aterros[j]
                if (insideGeofence(position, aterro)) {
                    in_aterro = true
                    aterro_name = aterro['name']
                    break
                }
            }

            //verifica se a posição está numa Localidade
            let in_localidade = false
            for (let j = 0 ; j < localidades.length ; j++) {
                const localidade = localidades[j]
                if (insideGeofence(position, localidade)){
                    in_localidade = true
                    break
                }
            }

            //primeira iteração
            if (in_estaleiro_old === undefined) {
                in_estaleiro_old = in_estaleiro
                in_aterro_old = in_aterro
                fixtime_old = position.fixTime
                coord_old = { latitude: position.latitude, longitude: position.longitude}
            }

            //espera que o veículo esteja dentro do estaleiro para começar
            if (service_status === 'fora' && in_estaleiro)
            {
                service_status = 'estaleiro'
            }

            let driver_da_viagem

            if (service_status === 'estaleiro' && !in_estaleiro && in_estaleiro_old) {
                console.log('*** Saiu do estaleiro')
                service_status = 'service'
                current_activity.device = device
                current_activity['saida_do_estaleiro'] = position.fixTime
                current_activity['estaleiro'] = estaleiro_name
                current_activity['km'] = 0
                current_activity['tempo_em_recolha'] = 0
                current_activity['tempo_em_aterro'] = 0
                current_activity['tempo_em_regresso'] = 0
                current_activity['entradas_em_aterro'] = 0
                current_activity['entrada_no_aterro'] = ''
                current_activity['tempo_excesso_localidade'] = 0
                current_activity['tempo_excesso_fora_localidade'] = 0
                current_activity['motorista'] = ''
                current_activity['viagens_sem_driver'] = 0
                driver_da_viagem = undefined
            }

            const time_since_last_position = new Date(position.fixTime) - new Date(fixtime_old)
            //está em serviço
            if (service_status === 'service') {

                const distance = coordsDistance(parseFloat(position.longitude), parseFloat(position.latitude),
                    parseFloat(coord_old.longitude), parseFloat(coord_old.latitude))

                current_activity['km'] += distance
                current_activity['tempo_em_recolha'] += time_since_last_position
                current_activity['tempo_em_regresso'] += time_since_last_position
                if (position['speed'] > speeding_localidade) {
                    current_activity['tempo_excesso_localidade'] += time_since_last_position
                }
                if (position['speed'] > speeding_fora_localidade) {
                    current_activity['tempo_excesso_fora_localidade'] += time_since_last_position
                }
                if (current_activity['motorista'] === "" && position['driverUniqueId'] && position['driverUniqueId'] !== "" && position['driverUniqueId'] !== "0") {
                    const driver = userData.drivers.find(d => d.uniqueId === position['driverUniqueId'])
                    current_activity['motorista'] = driver ? driver.name : ''
                }
                if (position['driverUniqueId'] && position['driverUniqueId'] !== "" && position['driverUniqueId'] !== "0") {
                    driver_da_viagem = position['driverUniqueId']
                }
            }

            //está em aterro
            if (service_status === 'aterro') {
                current_activity['tempo_em_aterro'] += time_since_last_position
            }

            //entrou no aterro
            if (service_status === 'service' && in_aterro && !in_aterro_old) {
                console.log("*** Entrou no aterro")
                service_status = 'aterro'

                current_activity['entradas_em_aterro'] += 1

                if (!current_activity['entrada_no_aterro']) {
                    current_activity['entrada_no_aterro'] = position.fixTime
                    current_activity['aterro'] = aterro_name
                }
                if (!driver_da_viagem) {
                    current_activity['viagens_sem_driver'] += 1
                }
                driver_da_viagem = undefined
            }

            //saiu do aterro
            if (service_status === 'aterro' && !in_aterro && in_aterro_old)
            {
                console.log("*** Saiu do aterro")
                service_status = 'service'
                current_activity['saida_do_aterro'] = position.fixTime
                current_activity['tempo_em_regresso'] = 0
            }

            //entrou no estaleiro
            if (service_status === 'service' && in_estaleiro && !in_estaleiro_old) {
                console.log("*** Entrou no estaleiro")
                service_status = 'estaleiro'


                //só aproveita a actividade se tiver passado num Aterro
                if (current_activity.entradas_em_aterro > 0) {

                    current_activity['entrada_no_estaleiro'] = position.fixTime
                    current_activity['tempo_em_trabalho'] = (new Date(current_activity['entrada_no_estaleiro']) - new Date(current_activity['saida_do_estaleiro'])).valueOf()
                    current_activity['tempo_em_recolha'] = current_activity['tempo_em_recolha'] - current_activity['tempo_em_regresso']
                    current_activity['horas_extra'] = 0

                    if (new Date(current_activity['entrada_no_estaleiro']).getHours() >= 15 &&
                        new Date(current_activity['entrada_no_estaleiro']).getHours() < 19) {

                        const entrada = new Date(current_activity['entrada_no_estaleiro'])
                        entrada.setHours(15, 0, 0, 0)
                        current_activity['horas_extra'] = new Date(current_activity['entrada_no_estaleiro']) - entrada
                    }

                    if (new Date(current_activity['entrada_no_estaleiro']).getHours() >= 5 &&
                        new Date(current_activity['entrada_no_estaleiro']).getHours() < 7) {
                        const entrada = new Date(current_activity['entrada_no_estaleiro'])
                        entrada.setHours(5, 0, 0, 0)
                        current_activity['horas_extra'] = new Date(current_activity['entrada_no_estaleiro']) - entrada
                    }

                    current_activity['data'] = new Date(current_activity['saida_do_aterro']).toLocaleDateString()

                    if (!driver_da_viagem) {
                        current_activity['viagens_sem_driver'] += 1
                    }

                    service_counter += 1

                    deviceActivities.activities.push({ ...current_activity })

                    deviceActivities.entradas_em_aterro += current_activity['entradas_em_aterro']
                    deviceActivities.km += current_activity['km']
                    deviceActivities.tempo_em_trabalho += current_activity['tempo_em_trabalho']
                    deviceActivities.tempo_em_recolha += current_activity['tempo_em_recolha']
                    deviceActivities.tempo_em_aterro += current_activity['tempo_em_aterro']
                    deviceActivities.tempo_em_regresso += current_activity['tempo_em_regresso']
                    deviceActivities.horas_extra += current_activity['horas_extra']
                    deviceActivities.tempo_excesso_localidade += current_activity['tempo_excesso_localidade']
                    deviceActivities.tempo_excesso_fora_localidade += current_activity['tempo_excesso_fora_localidade']
                    deviceActivities.viagens_sem_driver += current_activity['viagens_sem_driver']
                }
            }

            in_estaleiro_old = in_estaleiro
            in_aterro_old = in_aterro
            fixtime_old = position.fixTime

            coord_old = {latitude: position.latitude, longitude: position.longitude}
        }

        console.log("- Analyzing route - DONE")
        console.log("Handling device " + device.id + " - DONE (Events:" + service_counter + " / Duration: " + (new Date(Date.now()) - timer_start).toLocaleString() + ")")

        reportData.devices = reportData.devices.concat(deviceActivities.activities)
    }

    //calcula as médias
    if (reportData.devices.length > 0) {
        reportData['entradas_em_aterro'] = reportData.devices.reduce((a, b) => a + b.entradas_em_aterro, 0) / reportData.devices
        reportData['km'] = reportData.devices.reduce((a, b) => a + b.km, 0) / reportData.devices
        reportData['tempo_em_trabalho'] = reportData.devices.reduce((a, b) => a + b.tempo_em_trabalho, 0) / reportData.devices
        reportData['tempo_em_recolha'] = reportData.devices.reduce((a, b) => a + b.tempo_em_recolha, 0) / reportData.devices
        reportData['tempo_em_aterro'] = reportData.devices.reduce((a, b) => a + b.tempo_em_aterro, 0) / reportData.devices
        reportData['tempo_em_regresso'] = reportData.devices.reduce((a, b) => a + b.tempo_em_regresso, 0) / reportData.devices
        reportData['horas_extra'] = reportData.devices.reduce((a, b) => a + b.horas_extra, 0) / reportData.devices
        reportData['tempo_excesso_localidade'] = reportData.devices.reduce((a, b) => a + b.tempo_excesso_localidade, 0) / reportData.devices
        reportData['tempo_excesso_fora_localidade'] = reportData.devices.reduce((a, b) => a + b.tempo_excesso_fora_localidade, 0) / reportData.devices
        reportData['viagens_sem_driver'] = reportData.devices.reduce((a, b) => a + b.viagens_sem_driver, 0) / reportData.devices
    }

    return [reportData]
/*





        #Formata o resultado para aparecer bem no relatório
        for index, activity in enumerate(json_response['activity']):
        json_response['activity'][index]['veiculo'] = json_response['activity'][index]['veiculo']
        json_response['activity'][index]['motorista'] = json_response['activity'][index]['motorista']
        json_response['activity'][index]['data'] = json_response['activity'][index]['data']
        json_response['activity'][index]['estaleiro'] = json_response['activity'][index]['estaleiro'].replace("ESTALEIRO ", "")
        json_response['activity'][index]['saida_do_estaleiro'] = json_response['activity'][index]['saida_do_estaleiro'].strftime("%H:%M")
        json_response['activity'][index]['entrada_no_aterro'] = json_response['activity'][index]['entrada_no_aterro'].strftime("%H:%M")
        json_response['activity'][index]['aterro'] = json_response['activity'][index]['aterro'].replace("ATERRO ", "")
        json_response['activity'][index]['saida_do_aterro'] = json_response['activity'][index]['saida_do_aterro'].strftime("%H:%M")
        json_response['activity'][index]['entrada_no_estaleiro'] = json_response['activity'][index]['entrada_no_estaleiro'].strftime("%H:%M")
        json_response['activity'][index]['entradas_em_aterro'] = json_response['activity'][index]['entradas_em_aterro']
        json_response['activity'][index]['km'] = round(json_response['activity'][index]['km'] / 1000, 1)
        json_response['activity'][index]['tempo_em_trabalho'] = common.get_hm(json_response['activity'][index]['tempo_em_trabalho'])
        json_response['activity'][index]['tempo_em_recolha'] = common.get_hm(json_response['activity'][index]['tempo_em_recolha'])
        json_response['activity'][index]['tempo_em_aterro'] = common.get_hm(json_response['activity'][index]['tempo_em_aterro'])
        json_response['activity'][index]['tempo_em_regresso'] = common.get_hm(json_response['activity'][index]['tempo_em_regresso'])
        json_response['activity'][index]['horas_extra'] = common.get_hm(json_response['activity'][index]['horas_extra'])
        json_response['activity'][index]['tempo_excesso_localidade'] = common.get_hm(json_response['activity'][index]['tempo_excesso_localidade'])
        json_response['activity'][index]['tempo_excesso_fora_localidade'] = common.get_hm(json_response['activity'][index]['tempo_excesso_fora_localidade'])
        json_response['activity'][index]['viagens_sem_driver'] = json_response['activity'][index]['viagens_sem_driver']

        if len(json_response['activity']) > 0:
        json_response['activity_sum']['km'] = round(json_response['activity_sum']['km'] / 1000, 1)
        json_response['activity_sum']['tempo_em_trabalho'] = common.get_hm(json_response['activity_sum']['tempo_em_trabalho'])
        json_response['activity_sum']['tempo_em_recolha'] = common.get_hm(json_response['activity_sum']['tempo_em_recolha'])
        json_response['activity_sum']['tempo_em_aterro'] = common.get_hm(json_response['activity_sum']['tempo_em_aterro'])
        json_response['activity_sum']['tempo_em_regresso'] = common.get_hm(json_response['activity_sum']['tempo_em_regresso'])
        json_response['activity_sum']['horas_extra'] = common.get_hm(json_response['activity_sum']['horas_extra'])
        json_response['activity_sum']['tempo_excesso_localidade'] = common.get_hm(json_response['activity_sum']['tempo_excesso_localidade'])
        json_response['activity_sum']['tempo_excesso_fora_localidade'] = common.get_hm(json_response['activity_sum']['tempo_excesso_fora_localidade'])
        json_response['activity_sum']['viagens_sem_driver'] = json_response['activity_sum']['viagens_sem_driver']

        json_response['activity_avg']['entradas_em_aterro'] = round(json_response['activity_avg']['entradas_em_aterro'], 1)
        json_response['activity_avg']['km'] = round(json_response['activity_avg']['km'] / 1000, 1)
        json_response['activity_avg']['tempo_em_trabalho'] = common.get_hm(json_response['activity_avg']['tempo_em_trabalho'])
        json_response['activity_avg']['tempo_em_recolha'] = common.get_hm(json_response['activity_avg']['tempo_em_recolha'])
        json_response['activity_avg']['tempo_em_aterro'] = common.get_hm(json_response['activity_avg']['tempo_em_aterro'])
        json_response['activity_avg']['tempo_em_regresso'] = common.get_hm(json_response['activity_avg']['tempo_em_regresso'])
        json_response['activity_avg']['horas_extra'] = common.get_hm(json_response['activity_avg']['horas_extra'])
        json_response['activity_avg']['tempo_excesso_localidade'] = common.get_hm(json_response['activity_avg']['tempo_excesso_localidade'])
        json_response['activity_avg']['tempo_excesso_fora_localidade'] = common.get_hm(json_response['activity_avg']['tempo_excesso_fora_localidade'])
        json_response['activity_avg']['viagens_sem_driver'] = round(json_response['activity_avg']['viagens_sem_driver'], 1)
    else:
        json_response['activity_sum'] = []
        json_response['activity_avg'] = []

        if len(json_response['activity']) == 0:
        json_response['server_message'] = common.language_strings['common'][user_language]['no_data']
        json_response['server_render'] = True

        return json_response*/
}

function exportVistaWasteActivityReportToPDF(userData, reportData){
    console.log('Export to PDF')

    const headers = [
        'Veículo',
        'Matrícula',
        'Grupo',
        'Data',
        'Estaleiro',
        'Entrada Estaleiro',
        'Saída Estaleiro',
        'Aterro',
        'Entrada Aterro',
        'Saída Aterro',
        'Entradas Aterro',
        'Kms',
        'Tempo Trabalho',
        'Tempo Recolha',
        'Tempo Aterro',
        'Tempo Regresso',
        'Horas Extra',
        'Vel. Dentro Localidades',
        'Vel. Fora Localidades',
        'Viagens sem Motorista'
    ]

    const doc = new jsPDF.jsPDF('l');
    doc.setFontSize(14)
    doc.text('Relatório de Actividade VistaWaste', 15, 15 )

    let data = []
    reportData.devices.forEach(d => {
        try {
            const group = userData.groups.find(g => d.device.groupId === g.id)

            const temp = [
                d.device.name,
                d.device.attributes.license_plate,
                group ? group.name : '',
                d.data,
                d.estaleiro.replace('ESTALEIRO ', ''),
                new Date(d.entrada_no_estaleiro).toLocaleTimeString(),
                new Date(d.saida_do_estaleiro).toLocaleTimeString(),
                d.aterro.replace('ATERRO ', ''),
                new Date(d.entrada_no_aterro).toLocaleTimeString(),
                new Date(d.saida_do_aterro).toLocaleTimeString(),
                d.entradas_em_aterro,
                (d.km/1000).toFixed(1),
                convertMS(d.tempo_em_trabalho),
                convertMS(d.tempo_em_recolha),
                convertMS(d.tempo_em_aterro),
                convertMS(d.tempo_em_regresso),
                convertMS(d.horas_extra),
                convertMS(d.tempo_excesso_localidade),
                convertMS(d.tempo_excesso_fora_localidade),
                d.viagens_sem_driver
            ]

            data.push(temp)

        } catch (e) {
            console.error(e, 'moving on...')
        }
    })

    const footValues = [
        'Total:' + reportData.devices.length,
        '',
        '',
        '',
        '',
        ''
    ]

    doc.autoTable({
        head: [headers],
        body: data,
        foot: [footValues],
        showFoot: 'lastPage',
        headStyles: {
            fillColor: reportStyle.pdfHeaderColor,
            textColor: reportStyle.pdfHeaderTextColor,
            fontSize: 7,
        },
        bodyStyles: {
            fillColor: reportStyle.pdfBodyColor,
            textColor: reportStyle.pdfBodyTextColor,
            fontSize: 6,
        },
        footStyles: {
            fillColor: reportStyle.pdfFooterColor,
            textColor: reportStyle.pdfFooterTextColor
        },
        startY: 25 });

    return doc
}

function exportVistaWasteActivityReportToExcel(userData, reportData){
    console.log('Export to Excel')

    const settings = {
        sheetName: 'Relatório Actividade VistaWaste', // The name of the sheet
        fileName: 'actividade_vistawaste' // The name of the spreadsheet
    }

    const headers = [
        {label: 'Veículo', value: 'veiculo'},
        {label: 'Matrícula', value: 'matricula'},
        {label: 'Grupo', value: 'grupo'},
        {label: 'Data', value: 'data'},
        {label: 'Estaleiro', value: 'estaleiro'},
        {label: 'Entrada Estaleiro', value: 'entrada_estaleiro'},
        {label: 'Saída Estaleiro', value: 'saida_estaleiro'},
        {label: 'Aterro', value: 'aterro'},
        {label: 'Entrada Aterro', value: 'entrada_aterro'},
        {label: 'Saída Aterro', value: 'saida_aterro'},
        {label: 'Entradas Aterro', value: 'entradas_aterro'},
        {label: 'Kms', value: 'kms'},
        {label: 'Tempo Trabalho', value: 'tempo_trabalho'},
        {label: 'Tempo Recolha', value: 'tempo_recolha'},
        {label: 'Tempo Aterro', value: 'tempo_aterro'},
        {label: 'Tempo Regresso', value: 'tempo_regresso'},
        {label: 'Horas Extra', value: 'horas_extra'},
        {label: 'Vel. Dentro Localidades', value: 'vel_dentro_localidade'},
        {label: 'Vel. Fora Localidades', value: 'vel_fora_localidade'},
        {label: 'Viagens sem Motorista', value: 'viagens_sem_motorista'}
    ]

    let data = []

    reportData.devices.forEach(d => {
        const group = userData.groups.find(g => d.device.groupId === g.id)

        data = data.concat([{
            veiculo: d.device.name,
            matricula: d.device.attributes.license_plate,
            grupo: group ? group.name : '',
            data: d.data,
            estaleiro: d.estaleiro.replace('ESTALEIRO ', ''),
            entrada_estaleiro: new Date(d.entrada_no_estaleiro).toLocaleTimeString(),
            saida_estaleiro: new Date(d.saida_do_estaleiro).toLocaleTimeString(),
            aterro: d.aterro.replace('ATERRO ', ''),
            entrada_aterro: new Date(d.entrada_no_aterro).toLocaleTimeString(),
            saida_aterro: new Date(d.saida_do_aterro).toLocaleTimeString(),
            entradas_aterro: d.entradas_em_aterro,
            kms: (d.km/1000).toFixed(1),
            tempo_trabalho: convertMS(d.tempo_em_trabalho),
            tempo_recolha: convertMS(d.tempo_em_recolha),
            tempo_aterro: convertMS(d.tempo_em_aterro),
            tempo_regresso: convertMS(d.tempo_em_regresso),
            horas_extra: convertMS(d.horas_extra),
            vel_dentro_localidade: convertMS(d.tempo_excesso_localidade),
            vel_fora_localidade: convertMS(d.tempo_excesso_fora_localidade),
            viagens_sem_motorista: d.viagens_sem_driver
        }])
    })
    console.log(data)
    return {
        headers,
        data,
        settings
    }
}

exports.createVistaWasteActivityReport = createVistaWasteActivityReport;
exports.exportVistaWasteActivityReportToPDF = exportVistaWasteActivityReportToPDF;
exports.exportVistaWasteActivityReportToExcel = exportVistaWasteActivityReportToExcel;
